export default "/_next/static/videos/9299f888a7764ef74ad0ac1680cbc987.mp4";